import { withVersions } from "v2/hocs/withVersions";
import withHeader from "v2/components/Header/hocs/withHeader";
import { Header as HeaderV1 } from "v2/components/Header/ui/Header/v1";
import { Header as HeaderV2 } from "v2/components/Header/ui/Header/v2";

const Header = withVersions({
  v1: withHeader(HeaderV1),
  v2: withHeader(HeaderV2),
});

export { Header };
